function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.85934 8.24449L11.8175 11.3212C12.0678 11.5815 12.0595 11.9965 11.7994 12.2467C11.677 12.3645 11.5158 12.4293 11.3458 12.4293C11.1663 12.4293 10.9987 12.358 10.8741 12.2286L7.89342 9.12859C7.04707 9.72337 6.05714 10.0367 5.01834 10.0367C2.25127 10.0367 0 7.78542 0 5.01834C0 2.25127 2.25127 0 5.01834 0C7.78542 0 10.0367 2.25127 10.0367 5.01834C10.0367 6.20267 9.61995 7.34031 8.85934 8.24449ZM8.72799 5.01834C8.72799 2.97304 7.06409 1.30913 5.01878 1.30913C2.97348 1.30913 1.30957 2.97304 1.30957 5.01834C1.30957 7.06365 2.97348 8.72755 5.01878 8.72755C7.06409 8.72755 8.72799 7.06365 8.72799 5.01834Z",
  fill: "#4F86C6"
});
const SvgSearchIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};
const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgSearchIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/search-icon.e25110cd.svg";
export { ForwardRef as ReactComponent };